import { createClient } from '@supabase/supabase-js';

// Both values are PUBLIC and end up in the JavaScript bundle. That is by
// design: the anon key only grants what Row Level Security allows, and every
// policy is in supabase/migrations/.
//
// The service_role key must NEVER appear in this file or any VITE_ variable.
// It bypasses RLS entirely.
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    'Missing Supabase configuration. Copy .env.example to .env.local and fill in ' +
      'VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY from your Supabase project ' +
      '(Project Settings -> API), then restart the dev server.',
  );
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    // Needed so the Google redirect back into the app is turned into a session
    detectSessionInUrl: true,
    // PKCE is the recommended flow for browser apps
    flowType: 'pkce',
  },
});
